import { AxiosResponse } from 'axios';
import { BaseServiceClient } from '../service-client/BaseServiceClient';

export interface DateRange {
  start: number;
  end: number;
}

export interface EventsQueryOptions {
  dateRange: DateRange;
  type?: string | string[];
  limit?: number;
}

export interface Event {
  timestamp: string;
  identity: string;
  type: string;
  id: string;
  entityId: string;
}

export interface EventsResponse<T> {
  events: T[];
}

export default class EventstoreClient<T> extends BaseServiceClient {
  public async events(options: EventsQueryOptions): Promise<AxiosResponse<EventsResponse<T>>> {
    const {
      dateRange: { start, end },
      limit,
    } = options;
    let { type } = options;

    if (type) {
      if (Array.isArray(type)) {
        type = JSON.stringify(type);
      }
    }

    return await this.httpClient.get('/events', {
      params: {
        start,
        end,
        type,
        limit,
      },
      ...this.requestConfig,
    });
  }
}
